import {
	getNetworkDisplayName,
	SUPPORTED_POOL_NETWORKS,
	type SupportedPoolNetwork,
} from "@/lib/pools/chains";

export { SUPPORTED_POOL_NETWORKS, type SupportedPoolNetwork };

const SUPPORTED_NETWORK_LOOKUP = new Set(
	SUPPORTED_POOL_NETWORKS.map((network) => network.toLowerCase()),
);

/** Accepts display name (`Ethereum`) or URL slug (`ethereum`). */
export function isSupportedPoolNetwork(network: string | null | undefined): boolean {
	if (!network?.trim()) return false;
	return SUPPORTED_NETWORK_LOOKUP.has(network.trim().toLowerCase());
}

export function filterPoolsBySupportedNetworks<T extends { network: string }>(pools: T[]): T[] {
	return pools.filter((pool) => isSupportedPoolNetwork(pool.network));
}

/** Title-case label; known chains use the canonical display name. */
export function formatNetworkLabel(network: string): string {
	return getNetworkDisplayName(network.trim());
}
